import { quickUpdates } from '@/mocks/homeData';

const toneMap: Record<string, string> = {
  primary: 'bg-primary-100 text-primary-700',
  accent: 'bg-accent-100 text-accent-700',
  secondary: 'bg-secondary-100 text-secondary-800',
};

const markMap: Record<string, string> = {
  热: 'bg-primary-500 text-background-50',
  新: 'bg-accent-500 text-background-50',
  修: 'bg-secondary-500 text-background-50',
};

export default function QuickFeed() {
  return (
    <section id="feed" className="mx-auto w-full max-w-7xl px-4 md:px-6">
      <div className="grid gap-10 lg:grid-cols-[220px_1fr] lg:gap-14">
        <div className="lg:pt-2">
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-primary-600">实时线 · FEED</p>
          <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            今日吃瓜快讯
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600">
            按时间排的更新流，新增、补档与热更都从这里滚动出来，带你回到完整合集索引。
          </p>
          <a
            href="#packs"
            className="mt-5 inline-flex items-center gap-2 whitespace-nowrap text-sm font-semibold text-primary-700 transition-colors hover:text-primary-800"
          >
            进入合集总览
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <div>
          <ol className="relative space-y-3 border-l border-background-200 pl-6 md:pl-8">
            {quickUpdates.map((item) => (
              <li key={item.time} className="relative">
                <span className="absolute -left-[31px] top-5 h-2.5 w-2.5 rounded-full border-2 border-background-50 bg-primary-500 md:-left-[39px]"></span>
                <article className="group rounded-lg border border-background-200 bg-background-50 p-4 transition-colors hover:border-primary-200 hover:bg-background-100 md:p-5">
                  <div className="flex flex-wrap items-center gap-x-3 gap-y-1.5">
                    <span className="font-mono text-sm font-semibold text-foreground-800">
                      {item.date} · {item.time}
                    </span>
                    <span className={`inline-flex items-center whitespace-nowrap rounded-full px-2 py-0.5 text-[11px] font-semibold ${toneMap[item.tone]}`}>
                      {item.tag}
                    </span>
                    <span className={`ml-auto inline-flex h-5 min-w-5 items-center justify-center rounded-full px-1.5 text-[10px] font-bold text-background-50 ${markMap[item.mark]}`}>
                      {item.mark}
                    </span>
                  </div>
                  <h3 className="mt-2.5 text-base font-semibold leading-snug text-foreground-950 md:text-[17px]">
                    {item.title}
                  </h3>
                  <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">{item.brief}</p>
                </article>
              </li>
            ))}
          </ol>
          <div className="mt-4 flex items-center gap-2 pl-1 text-sm text-foreground-500">
            <i className="ri-loader-4-line animate-spin text-accent-600"></i>
            <span>快讯流持续滚动更新，合集结构保持稳定</span>
          </div>
        </div>
      </div>
    </section>
  );
}